import React from 'react';
import { useLang } from '../context/LanguageContext';
import { t } from '../data/translations';
import { CheckCircle } from 'lucide-react';

const AboutSection = () => {
  const { lang } = useLang();

  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left - Image */}
          <div className="aspect-[4/3] overflow-hidden bg-[#E2E8F0]">
            <img
              src="https://images.unsplash.com/photo-1622122328143-8e2269e8d3ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBmb29kJTIwcGFja2FnaW5nJTIwZmFjdG9yeSUyMHdvcmtlcnMlMjBjbGVhbnxlbnwwfHx8fDE3NzYzNDAyNjJ8MA&ixlib=rb-4.1.0&q=85"
              alt="Modern food packaging factory"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          {/* Right - Text */}
          <div>
            <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB] font-['Manrope'] mb-4">
              {t.about.overline[lang]}
            </span>
            <h2
              data-testid="about-title"
              className="font-['Outfit'] text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A] leading-tight mb-6"
            >
              {t.about.title[lang]}
            </h2>
            <p className="font-['Manrope'] text-base md:text-lg text-[#475569] leading-relaxed mb-4">
              {t.about.text1[lang]}
            </p>
            <p className="font-['Manrope'] text-base md:text-lg text-[#475569] leading-relaxed mb-8">
              {t.about.text2[lang]}
            </p>

            {/* Values */}
            <div className="grid grid-cols-2 gap-3">
              {t.about.values[lang].map((value, i) => (
                <div key={i} className="flex items-center gap-2">
                  <CheckCircle className="w-4 h-4 text-[#2563EB] flex-shrink-0" strokeWidth={1.5} />
                  <span className="font-['Manrope'] text-sm font-medium text-[#1E293B]">{value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
